<div class="courses">
  <div class="cards-container">
    @for (card of cards; track card._id) {
      <ptl-card-item
        role="listitem"
        class="card-item"
        [card]="card"
        [viewType]="currentLayoutView"
        [ngClass]="{ 'full-width': currentLayoutView !== 'CardView' }"
        (cardClick)="onCardClick($event)"
      ></ptl-card-item>
    }
  </div>
</div>
